import type { RouterHistory } from '@tanstack/react-router'; // Import BeforeLoadContextOptions
import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import PageNotFound from '@/components/Error/PageNotFound/PageNotFound';
import type { QueryClient } from '@tanstack/react-query';
import { AppAuthContext } from './types/auth';

export interface RouterContext {
  auth: AppAuthContext;
  queryClient: QueryClient;
}

export const createAppRouter = ({ history }: { history?: RouterHistory }) => {
  const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
    history,
    defaultNotFoundComponent: PageNotFound,
    context: {
      auth: {
        isAuthenticated: false,
        isLoading: true,
        user: undefined,
        loginWithRedirect: async () => {},
        getAccessTokenSilently: async () => '',
        logout: async () => {},
      } as AppAuthContext,
      queryClient: undefined!,
    },
  });

  return router;
};

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}

export type AppRouter = ReturnType<typeof createAppRouter>;
